import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@beef/ui-kit';
import { useShowFixedActionBar } from "./hooks/useShowActionBar";
import { Link } from "./components/Link";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var FixedActionBar = /*#__PURE__*/memo(function (_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    link = _ref.link,
    extraLink = _ref.extraLink,
    button = _ref.button,
    onClick = _ref.onClick,
    _ref$withoutHidden = _ref.withoutHidden,
    withoutHidden = _ref$withoutHidden === void 0 ? false : _ref$withoutHidden,
    blockIndex = _ref.blockIndex;
  var isHidden = useShowFixedActionBar(withoutHidden);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', {
      'container--hidden': isHidden
    }),
    "data-t-id": "components-FixedActionBar"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('content', {
      'content--right': !title
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('texts')
  }, title && /*#__PURE__*/React.createElement(Text, {
    size: "size4-m"
  }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-s"
  }, subTitle)), /*#__PURE__*/React.createElement("div", {
    className: cn('actions')
  }, (link === null || link === void 0 ? void 0 : link.text) && /*#__PURE__*/React.createElement(Link, _extends({}, link, {
    blockIndex: blockIndex,
    buttonVariant: link.buttonVariant || 'main'
  })), (extraLink === null || extraLink === void 0 ? void 0 : extraLink.text) && /*#__PURE__*/React.createElement(Link, _extends({}, extraLink, {
    blockIndex: blockIndex,
    buttonVariant: extraLink.buttonVariant || 'tertiary'
  })), (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/React.createElement(Button, _extends({}, button, {
    onClick: onClick,
    size: button.size || 'm'
  }), button.text))));
});
FixedActionBar.displayName = FixedActionBar.name;